import { render, staticRenderFns } from "./Admin-Panel.vue?vue&type=template&id=6cd07871&scoped=true"
import script from "./Admin-Panel.vue?vue&type=script&lang=js"
export * from "./Admin-Panel.vue?vue&type=script&lang=js"
import style0 from "./Admin-Panel.vue?vue&type=style&index=0&id=6cd07871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd07871",
  null
  
)

export default component.exports